import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/font-awesome/5.15.3/css/all.css";
import "./assets/css/custom.css";
import 'floating-vue/dist/style.css';
import 'vue3-toastify/dist/index.css';
import ArgonDashboard from "./argon-dashboard";
import FloatingVue from 'floating-vue';
import VueMask from '@devindex/vue-mask';
import VueTheMask from 'vue-the-mask';
import './registerServiceWorker';
import money from 'v-money';
import "./assets/css/font.css"
import "./assets/css/transactions.css"

import ptBR from "./locales/pt-BR.json";
import es from "./locales/es.json";
import en from "./locales/en.json";

import { createI18n } from "vue-i18n";

function getBrowserLanguage() {
  const browserLanguage = window.navigator.language;
  console.log(browserLanguage);
  // You would add logic here to match the browser language to one of your supported locales
  // For example, if browserLanguage is 'en-US', you might use 'en'
  const supportedLocales = ['pt-br', 'pt-BR', 'en', 'es']; // your app's supported languages
  const localeMatch = supportedLocales.find(locale => browserLanguage.startsWith(locale));
  console.log(localeMatch);
  return localeMatch || 'pt-br'; // fall back to a default
}

const i18n = createI18n({
  locale: getBrowserLanguage(),
  fallbackLocale: 'pt-BR',
  messages: {
    "en": en,
    "pt-BR": ptBR,
    "pt-br": ptBR,
    "es": es,
  },
})

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(FloatingVue);
appInstance.use(VueMask);
appInstance.use(VueTheMask);
appInstance.use(money, {precision: 4});
appInstance.use(i18n);
appInstance.mount("#app");
